import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
// import TeamMembers from "./TeamMembers";
import Pagination from 'sharedComponents/Pagination';
import AdminAccountsList from './AdminAccountsList';
import WorkspaceListSearch from '../workspace/WorkspaceListSearch';
import { useWorkspaces } from 'hooks/Workspace/useWorkSpaces';

const ADMIN_ACCOUNTS_DATA = [
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
  {
    id: 1,
    name: 'Jaco',
    surname: 'Gerrits',
    email: 'email@gmail.com',
    lastActivity: '21 Sep 2023, 10:32:12am',
  },
];

const SWITCH_BUTTONS = [
  {
    id: 1,
    label: 'Accounts',
  },
  {
    id: 2,
    label: 'Users',
  },
  {
    id: 3,
    label: 'Workspaces',
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function AdminPanels(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box hidden={value !== index} {...other}>
      {value === index && (
        <Box sx={{ py: 3, px: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

function AdminContainer() {
  const [value, setValue] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const { workspaces } = useWorkspaces();

  const itemsPerPage = 4;
  const currentAdminAccounts = React.useMemo(() => {
    const firstPageIndex = (currentPage - 1) * itemsPerPage;
    const lastPageIndex = firstPageIndex + itemsPerPage;
    return ADMIN_ACCOUNTS_DATA.slice(firstPageIndex, lastPageIndex);
  }, [currentPage]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Grid container padding={3}>
      <Grid item alignItems='center' xs={12}>
        <Box display='flex' align-items='center' justifyContent='space-between'>
          <Typography variant='h4'>Admin</Typography>
        </Box>
      </Grid>

      <Grid container item display='flex' alignItems='center'>
        <Box mt={4} sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              sx={{
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {SWITCH_BUTTONS.map((button) => (
                <Tab
                  sx={{
                    '&.Mui-selected': {
                      backgroundColor: '#6267ac',
                      border: 'none',
                      color: '#ffffff',
                    },
                  }}
                  label={button.label}
                />
              ))}
            </Tabs>
          </Box>
          <AdminPanels value={value} index={0}>
            <Grid item alignItems='center' xs={12}>
              <Box
                sx={{
                  mb: 2,
                  maxHeight: 500,
                  mt: 0,
                  backgroundColor: '#F9F9F9',
                  boxShadow: 'none',
                }}
              >
                <AdminAccountsList />
              </Box>
            </Grid>

            <Pagination
              itemsPerPage={itemsPerPage}
              dataCount={ADMIN_ACCOUNTS_DATA.length}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </AdminPanels>
          <AdminPanels value={value} index={2}>
            <Grid container item alignItems='center' width='100%'>
              <WorkspaceListSearch />
            </Grid>
          </AdminPanels>
        </Box>
      </Grid>
    </Grid>
  );
}

export default AdminContainer;
